import * as invoiceCoordinators from './invoice'

export default Object.freeze({
  ...invoiceCoordinators,
})
